import { useEffect, useState } from 'react'
import { SwitchButtonProps } from './switch-button.types'
import styles from './switch-button.module.scss'
import cl from 'classnames'
import { Button } from '@touche-lts/panel-ui/dist'

const SwitchButtonComponent = (props: SwitchButtonProps) => { // TODO-A This component may be moved to bit.dev
  const {
    isOn,
    alwaysSync,
    disabled,
    onChange,
    className,
    style
  } = props

  const [switchedOn, setSwitchedOn] = useState(!!isOn)

  useEffect(() => setSwitchedOn(isOn), [isOn])

  const switchOnOff = () => {
    const value = !switchedOn
    !alwaysSync && setSwitchedOn(value)
    onChange && onChange(value)
  }

  return (
    <Button
      preset='icon'
      className={cl(styles.container, {
        [styles.switchedOn]: switchedOn
      }, className)}
      style={style}
      onClick={switchOnOff}
      disabled={disabled}
    >
      <span className={styles.label}>YES</span>
      <div className={cl(styles.circle)} />
      <span className={styles.label}>NO</span>
    </Button>
  )
}

const SwitchButton = SwitchButtonComponent
export { SwitchButton }
